import { Pleb } from '../models/Pleb';
import { FakeData } from './FakeData';
import { Repository } from './Repository';

export class PlebsRepository extends Repository {

  async getUserDetails(id: string, currentUserId: string): Promise<Pleb> {
    const path = `v1/users/${id}`;

    try {
      if(Repository.offlineMode) {
        return FakeData.getPleb();
      }

      const response = await Repository.client.get(path);
      return Pleb.fromJson(response.data.data, currentUserId);
    } catch (err) {
      throw err;
    }
  }

  async getUsersNearby(
    latitude: number, 
    longitude: number, 
    filter: string | null, 
    currentUserId: string, 
    page: number, 
    itemsPerPage: number
  ): Promise<{data: Pleb[], count: number}> {
    if(Repository.offlineMode) {
      return {
        data: [FakeData.getPleb()],
        count: 1
      };
    }

    let path = `v2/nearby?latitude=${latitude}&longitude=${longitude}&includeAll=true&page=${page}&limit=${itemsPerPage}`;

    if(filter) {
      path += `&filter=${filter}`;
    }

    if(latitude !== 0 && longitude !== 0) {
      path += `&maxDistance=${500000}`;
    }

    const response = await Repository.client.get(path);
    if(response.data?.data?.users)
      return {
        data: response.data.data.users.map((user: any) => Pleb.fromJson(user, currentUserId)),
        count: response.data.data.count
      };
    else
      return {
        data: [],
        count: 0
      };
  }

  async updateUser(data: any): Promise<Pleb> {
    const path = `v1/users/me`;
    const response = await Repository.client.patch(path, data);
    return Pleb.currentUserFromJson(response.data.data);
  }

  async updatePicture(index: number, picture: File): Promise<Pleb> {
    const path = `v1/users/me/pictures/${index}`;
    
    const formData = new FormData();
    formData.append('picture', picture);

    try {
      const response = await Repository.client.post(path, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return Pleb.currentUserFromJson(response.data.data);
    } catch (err) {
      throw err;
    }
  }

  async removePicture(index: number): Promise<Pleb> {
    const path = `v1/users/me/pictures/${index}`;
    
    try {
      const response = await Repository.client.delete(path);
      return Pleb.currentUserFromJson(response.data.data);
    } catch (err) {
      throw err;
    }
  }
}

// Create a singleton instance
export const plebsRepository = new PlebsRepository();
